export default "__VITE_ASSET__BwnCjdlp__"